import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Api } from '../../../api/api';
import { environment } from '../../../environment';
import { ESRI } from '../../../esri-loader-util';
import { InputConverter, JSONConverter } from '../../../inputConverter';
import { DistanceUnits, FillStyleOptions, LineStyleOptions } from '../../../selectionOptions';
import { BufferService } from '../../../services/buffer.service';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
var SketchViewModel;
var FeatureLayer;
var Query;
var GeometryService;
var DrawIntersectionComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DrawIntersectionComponent, _super);
    function DrawIntersectionComponent(_vcr, layerService, bufferService, api) {
        var _this = _super.call(this, _vcr) || this;
        _this.layerService = layerService;
        _this.bufferService = bufferService;
        _this.api = api;
        _this.defaultSymbolProperties = {
            type: 'simple-marker',
            style: 'circle',
            name: 'Circle',
            color: 'rgba(255, 255, 255, 0.5)',
            size: 12,
            outline: {
                color: 'black',
                width: 1
            }
        };
        _this.debounceTimer = 1000;
        _this.intersectionClicks = new Subject();
        _this.drawComplete = new EventEmitter();
        _this.intersectionType = 'circle';
        _this.crossBufferOptions = {
            bufferDistance: 10,
            bufferDistanceUnit: 'feet',
            intersectionDistance: 100,
            intersectionDistanceUnit: 'feet'
        };
        _this.bufferOptions = {
            distance: _this.crossBufferOptions.intersectionDistance,
            distanceUnit: _this.crossBufferOptions.intersectionDistanceUnit,
            fillType: FillStyleOptions[0].value,
            fillColor: '#ff0000',
            outlineType: LineStyleOptions[0].value,
            outlineColor: '#ff0000',
            lineWidth: 2,
            opacity: 0.5
        };
        return _this;
    }
    Object.defineProperty(DrawIntersectionComponent.prototype, "enabled", {
        set: function (enabled) {
            this._enabled = enabled;
            this._enabled ? this.activate() : this.deactivate();
        },
        enumerable: true,
        configurable: true
    });
    DrawIntersectionComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, error_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 4, 5, 6]);
                        _b = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 1:
                        _b.mapView = _d.sent();
                        this.bufferDistanceUnits = DistanceUnits;
                        return [4 /*yield*/, Promise.all([ESRI.SketchViewModel, ESRI.FeatureLayer, ESRI.Query, ESRI.GeometryService])];
                    case 2:
                        _a = tslib_1.__read.apply(void 0, [_d.sent(), 4]), SketchViewModel = _a[0], FeatureLayer = _a[1], Query = _a[2], GeometryService = _a[3];
                        this.stateLayer = new FeatureLayer({
                            url: environment.apiBaseUrl + "/arcgis/paroads/1",
                            id: 'stateLayer',
                            outFields: ['ST_RT_NO', 'STREET_NAME', 'OBJECTID', 'SEG_NO', 'SEG_LNGTH_FEET', 'CTY_CODE', 'JURIS', 'SIDE_IND'],
                            opacity: 0.7,
                            minScale: 25000,
                            listMode: 'hide',
                            visible: false
                        });
                        this.localLayer = new FeatureLayer({
                            url: environment.apiBaseUrl + "/arcgis/paroads/0",
                            id: 'localLayer',
                            outFields: ['LR_RT_NO', 'LR_NAME', 'LR_TYPE'],
                            opacity: 0.7,
                            minScale: 25000,
                            listMode: 'hide',
                            visible: false
                        });
                        this.selectedRoadLayer = new FeatureLayer({
                            url: environment.apiBaseUrl + "/arcgis/paroads/2",
                            id: 'selectedRoadLayer',
                            outFields: ['OBJECTID', 'GEOMETRY'],
                            opacity: 0.7,
                            minScale: 25000,
                            listMode: 'hide',
                            visible: false
                        });
                        this.stateLayer.mapcoreProps = { hideInLegend: true };
                        this.localLayer.mapcoreProps = { hideInLegend: true };
                        this.selectedRoadLayer.mapcoreProps = { hideInLegend: true };
                        _c = this;
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: 'Intersection', hideInLegend: true, listMode: 'hide' })];
                    case 3:
                        _c.snapLayer = _d.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _d.sent();
                        this.readyProblem(error_1);
                        return [3 /*break*/, 6];
                    case 5:
                        this.isReady();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    DrawIntersectionComponent.prototype.ngOnDestroy = function () {
        this.deactivate();
    };
    DrawIntersectionComponent.prototype.activate = function () {
        var _this = this;
        this.stateLayer.visible = true;
        this.localLayer.visible = true;
        this.selectedRoadLayer.visible = true;
        this.mapView.map.addMany([this.stateLayer, this.localLayer, this.selectedRoadLayer, this.snapLayer]);
        this.layerService.moveLayerToTheTop(this.stateLayer);
        this.layerService.moveLayerToTheTop(this.localLayer);
        this.layerService.moveLayerToTheTop(this.snapLayer);
        this.intersectionClicksSub = this.intersectionClicks.pipe(debounceTime(this.debounceTimer), distinctUntilChanged()).subscribe(function (event) {
            if (event.state === 'complete') {
                var graphic = event.graphic;
                _this.addGraphic(graphic);
                _this.createDrawAction();
            }
        });
        this.setSketchViewModel();
        this.createDrawAction();
    };
    DrawIntersectionComponent.prototype.deactivate = function () {
        this.intersectionClicksSub.unsubscribe();
        this.mapView.map.removeMany([this.stateLayer, this.localLayer, this.selectedRoadLayer, this.snapLayer]);
        this.sketchViewModel.cancel();
        if (this.sketchHandler) {
            this.sketchHandler.remove();
        }
    };
    DrawIntersectionComponent.prototype.createDrawAction = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (this.sketchHandler) {
                    this.sketchHandler.remove();
                }
                this.sketchViewModel.create('point');
                this.sketchHandler = this.sketchViewModel.on('create', function (event) {
                    _this.intersectionClicks.next(event);
                });
                return [2 /*return*/];
            });
        });
    };
    DrawIntersectionComponent.prototype.addGraphic = function (graphic) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var nameList, intersectionLayer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setIntersectionName(graphic.geometry)];
                    case 1:
                        nameList = _a.sent();
                        if (nameList.size === 0) {
                            this.snapLayer.removeAll();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: this.intersectionName, graphicLayer: 'polygon' })];
                    case 2:
                        intersectionLayer = _a.sent();
                        intersectionLayer.add(graphic);
                        if (!(this.intersectionType === 'cross')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.addIntersectionCross(graphic)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.addIntersectionCircle(graphic)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        this.drawComplete.emit(graphic);
                        return [2 /*return*/];
                }
            });
        });
    };
    DrawIntersectionComponent.prototype.addIntersectionCircle = function (graphic) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var point, circleOptions, circleBuffer, title, bufferLayer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        point = graphic.geometry;
                        circleOptions = tslib_1.__assign({}, this.bufferOptions, { distance: this.crossBufferOptions.intersectionDistance, distanceUnit: this.crossBufferOptions.intersectionDistanceUnit });
                        return [4 /*yield*/, this.bufferService.getGeometryBuffers(point, circleOptions)];
                    case 1:
                        circleBuffer = _a.sent();
                        title = this.intersectionName + " - Buffer (" + this.crossBufferOptions.intersectionDistance + " " + this.crossBufferOptions.intersectionDistanceUnit + ")";
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: title })];
                    case 2:
                        bufferLayer = _a.sent();
                        bufferLayer.addMany(circleBuffer.map(function (b) { return b.graphic; }));
                        return [2 /*return*/];
                }
            });
        });
    };
    DrawIntersectionComponent.prototype.addIntersectionCross = function (graphic) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var intersectionGeometries, point, objectIds, query, selectedFeatures, pointBuffer, localView, local, localRoadGeometries, crossOptions, intersectionBuffer, title, bufferLayer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        intersectionGeometries = [];
                        point = graphic.geometry;
                        return [4 /*yield*/, this.api.http2.post('mapLayer/get-offset-by-lat-long', {
                                latitude: point.latitude,
                                longitude: point.longitude,
                                bufferDistance: this.crossBufferOptions.intersectionDistance
                            }, { responseType: 'text' })];
                    case 1:
                        objectIds = _a.sent();
                        query = new Query();
                        query.where = "OBJECTID in (" + objectIds + ")";
                        query.returnGeometry = true;
                        return [4 /*yield*/, this.selectedRoadLayer.queryFeatures(query)];
                    case 2:
                        selectedFeatures = _a.sent();
                        if (selectedFeatures && selectedFeatures.features) {
                            intersectionGeometries = intersectionGeometries.concat(selectedFeatures.features.map(function (f) { return f.geometry; }));
                        }
                        return [4 /*yield*/, this.bufferService.getGeometryBuffers(point, this.bufferOptions)];
                    case 3:
                        pointBuffer = _a.sent();
                        return [4 /*yield*/, this.mapView.whenLayerView(this.localLayer)];
                    case 4:
                        localView = _a.sent();
                        return [4 /*yield*/, localView.queryFeatures({
                                geometry: graphic.geometry,
                                distance: 10,
                                units: 'feet',
                                returnGeometry: true
                            })];
                    case 5:
                        local = _a.sent();
                        if (!this.geometryService) {
                            this.geometryService = new GeometryService({ url: environment.geometryServiceUrl });
                        }
                        if (!(local.features && local.features.length > 0)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.geometryService.intersect(local.features.map(function (f) { return f.geometry; }), pointBuffer[0].graphic.geometry)];
                    case 6:
                        localRoadGeometries = _a.sent();
                        intersectionGeometries = intersectionGeometries.concat(localRoadGeometries);
                        _a.label = 7;
                    case 7:
                        crossOptions = tslib_1.__assign({}, this.bufferOptions, { distance: this.crossBufferOptions.bufferDistance, distanceUnit: this.crossBufferOptions.bufferDistanceUnit });
                        return [4 /*yield*/, this.bufferService.getGeometryBuffers(intersectionGeometries, crossOptions)];
                    case 8:
                        intersectionBuffer = _a.sent();
                        title = this.intersectionName + " - Buffer (" + this.crossBufferOptions.intersectionDistance + " " + this.crossBufferOptions.intersectionDistanceUnit + ")";
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: title })];
                    case 9:
                        bufferLayer = _a.sent();
                        bufferLayer.addMany(intersectionBuffer.map(function (b) { return b.graphic; }));
                        return [2 /*return*/];
                }
            });
        });
    };
    DrawIntersectionComponent.prototype.setIntersectionName = function (geometry) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, nameList, localView, local, stateView, state;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = new Query({
                            geometry: geometry,
                            distance: 10,
                            units: 'feet',
                            returnGeometry: true
                        });
                        nameList = new Set();
                        return [4 /*yield*/, this.mapView.whenLayerView(this.localLayer)];
                    case 1:
                        localView = _a.sent();
                        return [4 /*yield*/, localView.queryFeatures(query)];
                    case 2:
                        local = _a.sent();
                        local.features.forEach(function (feature) {
                            if (feature.attributes.LR_NAME !== null) {
                                nameList.add(feature.attributes.LR_NAME + " " + feature.attributes.LR_TYPE);
                            }
                        });
                        return [4 /*yield*/, this.mapView.whenLayerView(this.stateLayer)];
                    case 3:
                        stateView = _a.sent();
                        return [4 /*yield*/, stateView.queryFeatures(query)];
                    case 4:
                        state = _a.sent();
                        state.features.forEach(function (feature) {
                            if (feature.attributes.STREET_NAME !== null) {
                                nameList.add(feature.attributes.STREET_NAME);
                            }
                        });
                        this.intersectionName = Array.from(nameList).join(' x ');
                        return [2 /*return*/, nameList];
                }
            });
        });
    };
    DrawIntersectionComponent.prototype.setSketchViewModel = function () {
        if (!this.sketchViewModel) {
            this.sketchViewModel = new SketchViewModel({
                view: this.mapView,
                layer: this.snapLayer,
                pointSymbol: this.defaultSymbolProperties,
                snappingOptions: {
                    enabled: true,
                    distance: 30,
                    featureSources: [
                        { layer: this.localLayer },
                        { layer: this.stateLayer }
                    ]
                }
            });
        }
    };
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Object)
    ], DrawIntersectionComponent.prototype, "defaultSymbolProperties", void 0);
    return DrawIntersectionComponent;
}(BaseComponent));
export { DrawIntersectionComponent };
